import { withTranslation } from "react-i18next";
import { TextValidator } from "react-material-ui-form-validator";
import styles from "../nsc/deliveryRangesRow/NscDeliveryRangesRow.module.scss";
import Item from "../../../../shared/item/Item";
import React from "react";

const NewRangeRow = (props) => {
  function displayTo(val) {
    if (val === -1 || val === null) return "OVER";
    return val;
  }
  return (
    <>
      <TextValidator
        className={styles.textBox}
        style={{ marginTop: "10px", marginBottom: "10px" }}
        id={props.currentRow === null ? "" : props.currentRow.toString()}
        name={"rangeFrom" + props.currentRow.toString()}
        variant="outlined"
        value={props.dataObjItem.from === null ? "" : props.dataObjItem.from}
        onChange={props.action}
        validators={[
          "required",
          "matchRegexp:^[0-9\\b]+$",
          "checkingRows:" + `${props.currentRow}`,
          "shouldBeZero:" + `${props.currentRow}`,
        ]}
        errorMessages={[
          props.t("nscDeliveryBands.required"),
          props.t("nscDeliveryBands.isNumber"),
          props.t("nscDeliveryBands.invalid"),
          props.t("nscDeliveryBands.hasToBeZero"),
        ]}
      />
      <div className={styles.to}>
        <Item value={props.t("nscDeliveryBands.to")} />
      </div>
      <TextValidator
        className={styles.textBox}
        style={{ marginTop: "10px", marginBottom: "10px" }}
        id={props.currentRow === null ? "" : props.currentRow.toString()}
        name={"rangeTo" + props.currentRow.toString()}
        variant="outlined"
        value={displayTo(props.dataObjItem.to)}
        validators={[
          "required",
          "requiredToValue:" +
            `${props.currentRow}` +
            `${props.currentNoOfRows}`,
          "matchRegexp:^[A-Za-z0-9\\b]+$",
          "isBigger:" + `${props.dataObjItem.from}`,
          "isOverText:" + `${props.currentRow},` + `${props.currentNoOfRows}`,
        ]}
        errorMessages={[
          props.t("nscDeliveryBands.required"),
          props.t("nscDeliveryBands.invalid"),
          props.t("nscDeliveryBands.isNumber"),
          props.t("nscDeliveryBands.invalid"),
          props.t("nscDeliveryBands.invalid"),
        ]}
        onChange={props.action}
      />
    </>
  );
};

export default withTranslation("emp")(NewRangeRow);
